
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/kec/kectypes",
      function () {
        return require("private-next-pages/india/kec/kectypes.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/kec/kectypes"])
      });
    }
  